<template>
    <a class="font-josefin -mb-px font-semibold tracking-wider text-sm sm:text-base leading-8 uppercase py-1 border-b-2 border-transparent transition-color duration-400"
       :class="{ 'border-primary-600': isActive }"
       href="#"
       @click.prevent="activateTab"
    >
        <slot></slot>
    </a>
</template>

<script>
	export default {
        inject: ['tabsState'],

        computed: {
            tabName() {
                return this.$slots.default[0].text;
            },

            isActive() {
                return this.tabName === this.tabsState.activeTab;
            }
        },

        methods: {
            activateTab() {
                this.tabsState.activeTab = this.tabName;
            }
        }
	}
</script>
